import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Default";
import Footer from "../../components/Partials/Footer";
import Header from "../../components/Partials/Header";
import { useLocation } from "react-router-dom";
import { getItemMenu, getGlosario } from "../../assets/js/api";

export default function Glosario({ section_id }) {
    const location = useLocation();
    const [glosario, setGlosario] = useState(null);
    const [item, setItem] = useState(location.state?.item || null);
    const [selectedLetterRange, setSelectedLetterRange] = useState("A-F");
    const [openTerm, setOpenTerm] = useState(null);

    useEffect(() => {
        if (section_id && !item) {
            getItemMenu(section_id).then((foundItem) => {
                setItem(foundItem);
            });
        }
    }, [section_id, item]);

    useEffect(() => {
        if (selectedLetterRange && item) {
            getGlosarioByRange(selectedLetterRange, item).then((data) => setGlosario(data));
        }
    }, [selectedLetterRange, item]);

    const letterRanges = [
        { label: "A-F", letters: ["A", "B", "C", "D", "E", "F"] },
        { label: "G-L", letters: ["G", "H", "I", "J", "K", "L"] },
        { label: "M-S", letters: ["M", "N", "O", "P", "Q", "R", "S"] },
        { label: "T-Z", letters: ["T", "U", "V", "W", "X", "Y", "Z"] },
    ];

    const handleLetterRangeClick = (event, range) => {
        event.preventDefault();
        setSelectedLetterRange(range);
    };

    // Filtrar los términos de glosario según el rango seleccionado
    const getGlosarioByRange = async (range, item) => {
        const data = await getGlosario(range, item); // Asumiendo que la API se puede consultar con un rango
        return data;
    };

    const handleTermToggle = (termId, event) => {
        event.preventDefault();
        setOpenTerm(openTerm === termId ? null : termId);
    };

    return (
        <Layout pageMeta={{}}>
            <div className="page-container py-5 is-flex is-flex-direction-column">
                <Header />
                <main id="main" className="is-relative mb-7">
                    <div className="wrapper flow--xl">
                        <h1 className="has-text-centered">{item ? item.term : ""}</h1>
                        <p className="has-text-centered">{item ? item.abstract : ""}</p>
                    </div>
                    <div className="wrapper flow--2xl mt-7">
                        <nav aria-label="Índice alfabético">
                            <ol className="abc-list-glosario is-flex is-flex-wrap-wrap is-justify-content-center gap-2">
                                {letterRanges.map((range) => (
                                    <li key={range.label}>
                                        <a
                                            href="#"
                                            className={selectedLetterRange === range.label ? "abc-list__active" : ""}
                                            onClick={(event) => handleLetterRangeClick(event, range.label)}
                                        >
                                            {range.label}
                                        </a>
                                    </li>
                                ))}
                            </ol>
                        </nav>
                        <div className="columns is-centered">
                            <div className="column is-9-widescreen">
                                <div className="flow--l">
                                    {glosario && glosario.length > 0 ? (
                                        glosario.map((termino) => (
                                            <details
                                                className="horizontal"
                                                key={"termino_" + termino.section_id}
                                                open={openTerm === termino.section_id}
                                            >
                                                <summary onClick={(event) => handleTermToggle(termino.section_id, event)}>
                                                    <h2 className="has-text-weight-bold is-size-5">{termino.term}</h2>
                                                </summary>
                                                <div className="flow is-size-7">
                                                    <p>{termino.abstract}</p>
                                                </div>
                                            </details>
                                        ))
                                    ) : (
                                        <p>No hay resultados para esta selección.</p>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <Footer />
            </div>
        </Layout>
    );
}
